class DocumentationSelector {
    constructor() {
        this.selectElement = document.getElementById('declaration-select');
        this.downloadBtn = document.getElementById('download-btn');

        if (!this.selectElement || !this.downloadBtn) return;

        this.init();
    }

    init() {
        // Init Tom Select
        this.tomSelect = new TomSelect('#declaration-select', {
            placeholder: 'Search for a model...',
            maxOptions: null,
            sortField: {
            field: 'text',
            direction: 'asc'
            },
            onChange: (value) => this.handleChange(value)
        });

        //download
        this.downloadBtn.addEventListener('click', () => this.handleDownload());
    }

    handleChange(value) {
        if (value) {
            this.downloadBtn.disabled = false;
        } else {
            this.downloadBtn.disabled = true;
        }
    }

    handleDownload() {
        const selectedValue = this.tomSelect.getValue();
        if (selectedValue) {
            const option = this.selectElement.querySelector(`option[value="${selectedValue}"]`);
            const fileUrl = option?.dataset.url;

            if (fileUrl) {
            window.open(fileUrl, '_blank');
            }
        }
    }
  }

// Init dom
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new DocumentationSelector());
} else {
    new DocumentationSelector();
}